export default __webpack_public_path__ + "static/media/new-message-white.876d56fa.svg";